import React from 'react';
import styles from './Support.module.scss';
import logo from '../../../../assets/images/glon_logo.svg';

const supportEmail = 'glon@support.marceliwac.com';

export default function Support() {
  return (
    <div className={styles.support}>
      <img src={logo} alt="Logo" />
      <h1>Contact</h1>
      <p>
        For all types of support requests please contact Support at:{' '}
        <a href={`mailto:${supportEmail}`}>{supportEmail}</a>.
      </p>
    </div>
  );
}
